/* ============================================================
   BIENENHERZ - Mobile Menue: "Alle anzeigen"-Links v7
   - Injiziert in ALLE Submenus (auch tief verschachtelt)
   - Processed sowohl Template als auch gerenderte Drawer
   - Continuous polling fuer dynamische Symmetry-Drawer
   ============================================================ */

(function() {
  'use strict';

  var DEBUG = false;
  var POLL_INTERVAL = 400;
  var POLL_MAX = 60; // 24 Sekunden Polling

  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[BH-Overview v7]'].concat([].slice.call(arguments)));
    }
  }

  function isValidHref(href) {
    return href && href !== '#' && href !== '' && href.indexOf('javascript:') !== 0;
  }

  // Findet das direkte Sub-UL eines LI - schaut auch in tier-X-container DIVs rein
  function findSubmenuUl(li) {
    if (!li || !li.children) return null;

    for (var i = 0; i < li.children.length; i++) {
      var child = li.children[i];
      var cls = (typeof child.className === 'string') ? child.className : '';

      // Direkter UL/OL
      if (child.tagName === 'UL' || child.tagName === 'OL') {
        return child;
      }

      // Container-DIV (navigation__tier-X-container, etc.) - inneres UL holen
      if (cls.indexOf('navigation__tier') !== -1 ||
          cls.indexOf('navigation__child') !== -1 ||
          cls.indexOf('linklist__sublist') !== -1 ||
          cls.indexOf('submenu') !== -1) {
        var innerList = child.querySelector('ul, ol');
        if (innerList) return innerList;
      }
    }
    return null;
  }

  // Findet den direkten Anchor des LI (Kategorie-Link)
  function findParentLink(li) {
    if (!li || !li.children) return null;

    // 1. Direkt: <a> als direktes Kind
    for (var i = 0; i < li.children.length; i++) {
      var child = li.children[i];
      if (child.tagName === 'A' && child.getAttribute('href')) {
        return child;
      }
      // 2. <a> innerhalb eines direkten div/span
      if (child.tagName === 'DIV' || child.tagName === 'SPAN') {
        var nestedA = child.querySelector(':scope > a[href]');
        if (nestedA) return nestedA;
      }
    }

    // 3. Fallback: erstes <a> das nicht in einem Submenu liegt
    var allLinks = li.querySelectorAll('a[href]');
    for (var j = 0; j < allLinks.length; j++) {
      var link = allLinks[j];
      // Closest LI muss der aktuelle sein
      if (link.closest('li') !== li) continue;
      // Link darf nicht in einem Container sein (also keinem Sub-UL/Container des LI)
      var parent = link.parentElement;
      var inSub = false;
      while (parent && parent !== li) {
        var pcls = (typeof parent.className === 'string') ? parent.className : '';
        if (pcls.indexOf('navigation__tier-2') !== -1 ||
            pcls.indexOf('navigation__tier-3') !== -1 ||
            pcls.indexOf('navigation__child') !== -1 ||
            parent.tagName === 'UL' || parent.tagName === 'OL') {
          inSub = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (!inSub) return link;
    }
    return null;
  }

  function getHref(el) {
    if (!el) return null;
    if (el.tagName === 'A' && el.getAttribute('href')) return el.getAttribute('href');
    return el.getAttribute('data-href') || el.getAttribute('data-url') || null;
  }

  function buildOverviewLi(doc, label, href) {
    var overviewLi = doc.createElement('li');
    overviewLi.className = 'bh-overview-link-wrap navigation__item';
    overviewLi.setAttribute('data-bh-overview', '1');

    var overviewLink = doc.createElement('a');
    overviewLink.className = 'bh-overview-link';
    overviewLink.href = href;
    overviewLink.innerHTML = 'Alle <strong>' + label + '</strong> anzeigen <span aria-hidden="true">&rarr;</span>';

    overviewLi.appendChild(overviewLink);
    return overviewLi;
  }

  // Verarbeitet einen Container - injiziert in alle LIs mit Submenu
  function processContainer(rootEl, doc) {
    if (!rootEl) return 0;
    var listItems = rootEl.querySelectorAll('li');
    var injected = 0;

    listItems.forEach(function(li) {
      var submenu = findSubmenuUl(li);
      if (!submenu) return;
      if (submenu.tagName !== 'UL' && submenu.tagName !== 'OL') return;

      // SKIP top-level submenus (tier-2): kein "Alle Produkte anzeigen" auf oberster Ebene
      var submenuCls = (typeof submenu.className === 'string') ? submenu.className : '';
      if (submenuCls.indexOf('navigation__tier-2') !== -1 &&
          submenuCls.indexOf('navigation__tier-3') === -1) {
        return;
      }
      // Also skip wenn der Container (parent) tier-2 ist (manche Themes haben das anders)
      var parentCls = '';
      if (submenu.parentElement) {
        parentCls = (typeof submenu.parentElement.className === 'string') ? submenu.parentElement.className : '';
      }
      if (parentCls.indexOf('navigation__tier-2-container') !== -1) {
        return;
      }

      // Schon ein Overview-Link drin? (per Klasse oder data-Attr)
      if (submenu.querySelector(':scope > .bh-overview-link-wrap')) return;
      if (submenu.querySelector(':scope > [data-bh-overview]')) return;

      var parentLink = findParentLink(li);
      if (!parentLink) return;

      var href = getHref(parentLink);
      if (!isValidHref(href)) return;

      // Label aus Parent-Link
      var label = parentLink.textContent.trim().replace(/\s+/g, ' ');
      if (!label) {
        label = parentLink.getAttribute('aria-label') || 'Kategorie';
      }
      if (label.length > 35) label = label.substring(0, 33) + '...';

      var overviewLi = buildOverviewLi(doc || document, label, href);
      submenu.insertBefore(overviewLi, submenu.firstChild);
      injected++;
      log('Injected:', label, '->', href);
    });

    return injected;
  }

  // STRATEGIE 1: Template-Script modifizieren (proaktiv)
  function processTemplateScript() {
    var scripts = document.querySelectorAll('script.mobile-navigation-drawer-template');
    if (!scripts.length) return 0;
    var totalInjected = 0;

    scripts.forEach(function(templateScript) {
      var originalHTML = templateScript.innerHTML;
      if (!originalHTML || originalHTML.length < 100) return;

      var parser = new DOMParser();
      var doc = parser.parseFromString('<!DOCTYPE html><html><body><div id="bh-temp-root">' + originalHTML + '</div></body></html>', 'text/html');
      var root = doc.getElementById('bh-temp-root');
      if (!root) return;

      var injected = processContainer(root, doc);

      if (injected > 0) {
        templateScript.innerHTML = root.innerHTML;
        totalInjected += injected;
      }
    });

    if (totalInjected > 0) log('Template - total injected:', totalInjected);
    return totalInjected;
  }

  // STRATEGIE 2: Gerenderte Drawer im Live-DOM
  function processRenderedDrawers() {
    var drawers = document.querySelectorAll('div.mobile-navigation-drawer, [class*="mobile-navigation-drawer"]:not(script)');
    var totalInjected = 0;

    drawers.forEach(function(drawer) {
      var injected = processContainer(drawer, document);
      totalInjected += injected;
    });

    if (totalInjected > 0) log('Rendered drawers - total injected:', totalInjected);
    return totalInjected;
  }

  function processAll() {
    processTemplateScript();
    processRenderedDrawers();
  }

  function init() {
    log('Init v7');

    processAll();

    // MutationObserver: faengt Drawer-Renderings und nested expansions
    var observer = new MutationObserver(function(mutations) {
      var shouldProcess = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes.length > 0) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType === 1) {
              var className = (typeof node.className === 'string') ? node.className : '';
              if (className.indexOf('mobile-navigation-drawer') !== -1 ||
                  className.indexOf('navigation__tier') !== -1 ||
                  className.indexOf('navigation__child') !== -1 ||
                  (node.querySelector && node.querySelector('[class*="mobile-navigation-drawer"], [class*="navigation__tier"]'))) {
                shouldProcess = true;
                break;
              }
            }
          }
        }
        if (shouldProcess) break;
      }
      if (shouldProcess) {
        processAll();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-expanded', 'aria-hidden', 'data-state']
    });

    // Continuous Polling (24 Sek lang, dann stop)
    var checks = 0;
    var interval = setInterval(function() {
      processAll();
      checks++;
      if (checks >= POLL_MAX) clearInterval(interval);
    }, POLL_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();